import { type Cell, flexRender } from "@tanstack/react-table";

import { type BaseObject } from "../../../../evidence/base";
import { DataTableCell } from "../data-table-cell";

export function DataTableBodyCell<TData extends BaseObject>({
  cell,
  onClick,
}: {
  cell: Cell<TData, any>;
  onClick?: (e: React.MouseEvent<HTMLTableCellElement>) => void;
}) {
  return (
    <DataTableCell
      key={cell.id}
      id={cell.id}
      className={cell.column.columnDef.meta?.className}
      innerClassName={cell.column.id === "open" ? "!overflow-visible" : ""}
      columnSize={cell.column.getSize()}
      data-title={cell.column.columnDef.meta?.label}
      onClick={onClick}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </DataTableCell>
  );
}
